module.exports = __webpack_public_path__ + "img/iboshow2022-1.de013486.jpg";